export const pinDelivery = {
    showNewDeliveryContact: true,
    showAlertText: false,
};
